import { CheckBoxData } from 'src/app/shared/models';

export class CheckboxCommonItem {
  constructor(public data: CheckBoxData) {}

  valueChanged(): void {
    this.data.checked = !this.data.checked;
  }
}
